/**
 * abilityVfxOnTheHunt — Sivir R On the Hunt gold warband rally (SP-20).
 */
export function buildOnTheHunt(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1.85);
  const gold = mat(THREE, spec.color || 0xca8a04, 0.88);
  const amber = mat(THREE, 0xfacc15, 0.92);
  const pale = mat(THREE, 0xfde68a, 0.85);
  addRallyRings(THREE, group, s, gold, amber);
  addBannerSpike(THREE, group, s, amber, pale);
  addSpeedStreaks(THREE, group, s, amber, pale);
  group.userData = { shape: 'on_the_hunt' };
  return group;
}

function addRallyRings(THREE, group, s, gold, amber) {
  const outer = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.7, s * 1.15, 28).rotateX(-Math.PI / 2),
    gold
  );
  outer.position.y = 0.05;
  group.add(outer);
  const inner = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.35, s * 0.6, 22).rotateX(-Math.PI / 2),
    amber
  );
  inner.position.y = 0.08;
  group.add(inner);
}

function addBannerSpike(THREE, group, s, amber, pale) {
  const pole = new THREE.Mesh(new THREE.BoxGeometry(0.08 * s, 1.1 * s, 0.08 * s), amber);
  pole.position.y = 0.7 * s;
  group.add(pole);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.14 * s, 0.35 * s, 5), pale);
  tip.position.y = 1.35 * s;
  group.add(tip);
  const gem = new THREE.Mesh(new THREE.SphereGeometry(0.12 * s, 8, 8), pale);
  gem.position.y = 0.55 * s;
  group.add(gem);
}

function addSpeedStreaks(THREE, group, s, amber, pale) {
  for (let i = 0; i < 4; i += 1) {
    const side = i < 2 ? -1 : 1;
    const z = (i % 2 === 0 ? 0.25 : -0.35) * s;
    const streak = new THREE.Mesh(new THREE.BoxGeometry(0.08 * s, 0.05 * s, 0.7 * s), amber);
    streak.position.set(side * 0.65 * s, 0.35 * s, z);
    group.add(streak);
    const spark = new THREE.Mesh(new THREE.SphereGeometry(0.06 * s, 6, 6), pale);
    spark.position.set(side * 0.75 * s, 0.4 * s, z - 0.35 * s);
    group.add(spark);
  }
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
